__turbopack_context__.v({
  "Collapsible": "FormTagsInput-module-scss-module__GTRWtW__Collapsible",
  "Content": "FormTagsInput-module-scss-module__GTRWtW__Content",
  "Icon": "FormTagsInput-module-scss-module__GTRWtW__Icon",
  "Panel": "FormTagsInput-module-scss-module__GTRWtW__Panel",
  "Trigger": "FormTagsInput-module-scss-module__GTRWtW__Trigger",
  "addButton": "FormTagsInput-module-scss-module__GTRWtW__addButton",
  "badge": "FormTagsInput-module-scss-module__GTRWtW__badge",
  "col": "FormTagsInput-module-scss-module__GTRWtW__col",
  "disabled": "FormTagsInput-module-scss-module__GTRWtW__disabled",
  "error": "FormTagsInput-module-scss-module__GTRWtW__error",
  "errorMsg": "FormTagsInput-module-scss-module__GTRWtW__errorMsg",
  "header": "FormTagsInput-module-scss-module__GTRWtW__header",
  "hidePlaceholder": "FormTagsInput-module-scss-module__GTRWtW__hidePlaceholder",
  "hint": "FormTagsInput-module-scss-module__GTRWtW__hint",
  "input": "FormTagsInput-module-scss-module__GTRWtW__input",
  "inputContent": "FormTagsInput-module-scss-module__GTRWtW__inputContent",
  "inputLabel": "FormTagsInput-module-scss-module__GTRWtW__inputLabel",
  "primary": "FormTagsInput-module-scss-module__GTRWtW__primary",
  "required": "FormTagsInput-module-scss-module__GTRWtW__required",
  "root": "FormTagsInput-module-scss-module__GTRWtW__root",
  "row": "FormTagsInput-module-scss-module__GTRWtW__row",
  "secondary": "FormTagsInput-module-scss-module__GTRWtW__secondary",
  "selectedList": "FormTagsInput-module-scss-module__GTRWtW__selectedList",
  "textInput": "FormTagsInput-module-scss-module__GTRWtW__textInput",
  "title": "FormTagsInput-module-scss-module__GTRWtW__title",
  "warning": "FormTagsInput-module-scss-module__GTRWtW__warning",
});
